import { useState } from "react";

/**
 * Captures the state of the ad-hoc place of safety.
 *
 * This is useful to centralise as multiple components collaborate on
 * reading and writing this data.
 * @returns {Object} An object containing the state and setters for name, address, and postalCode.
 */
export const useAdHocPlaceOfSafety = ({
  name: initialName,
  address: initialAddress,
  postalCode: initialPostalCode,
}: {
  name?: string;
  address?: string;
  postalCode?: string;
}) => {
  const [name, setName] = useState<string>(initialName ?? "");
  const [address, setAddress] = useState<string>(initialAddress ?? "");
  const [postalCode, setPostalCode] = useState<string>(initialPostalCode ?? "");

  return {
    name,
    address,
    postalCode,
    setName,
    setAddress,
    setPostalCode,
  };
};
